/* eslint-disable import/prefer-default-export */
import env from '@config/env'
import axios from 'axios'
import { resellerApiWithToken, resellerApi } from './baseApi'

const storeApi = axios.create({
  baseURL: `${env.storeApi + env.apiPrefix}`,
})

export const getCities = (params) => storeApi.get('/cities', { params })
export const getCustomers = (params) => resellerApiWithToken.get('/resellers/customers', { params })
export const getResellers = (params) => resellerApiWithToken.get('/resellers/members', { params })
export const getShippingAddresses = (params) => resellerApiWithToken.get('/resellers/shipping_addresses', { params })
export const getProducts = (params) => resellerApiWithToken.get('/resellers/products', { params })
export const getPackage = (params) => resellerApiWithToken.get('/resellers/product_packages', { params })
export const getWarehouses = (params) => resellerApiWithToken.get('/resellers/warehouses', { params })
export const getSources = (params) => resellerApiWithToken.get('/resellers/warehouses/sources', { params })
export const getTargets = (params) => resellerApiWithToken.get('/resellers/warehouses/targets', { params })
export const getProductCategories = (params) => resellerApiWithToken.get('/resellers/categories', { params })
export const getCouriers = (params) => resellerApiWithToken.get('/resellers/couriers', { params })
export const getCitiesOrDistricts = (params) => resellerApiWithToken.get('/autocompletes/districts', { params })
export const getBanks = (params) => resellerApiWithToken.get('/resellers/banks', { params })
export const getMemberships = (params) => resellerApiWithToken.get('/resellers/memberships', { params })
export const getOrderChannel = (params) => resellerApiWithToken.get('/resellers/order_channels', { params: { ...params, status: true } })
export const checkPackageStock = (params) => resellerApi.get('/api/v1/resellers/stocks/reseller_registration', { params })
